/*
 * Copyright Mission 42 Ventures, Inc. All rights reserved.
 * Unauthorized copying, distribution, or use is prohibited.
 */

import React from 'react';
import { SidebarItem } from '@backstage/core-components';
import DeviceHubIcon from '@material-ui/icons/DeviceHub';

export const McpCatalogSidebarItem = () => (
  <SidebarItem icon={DeviceHubIcon} to="/mcp-catalog" text="MCP Catalog" />
);
